// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"bdbc0653","47":"1855b714"}[chunkId] + ".chunk.js";
};